<template lang="pug">
#desktop
  .container.viewport(:class="{ active: !header }")
    .content.d-flex.flex-row
      leftBar
      mainPanel
      rightBar.flex-fill
</template>

<script>
// import leftBar from "@/components/desktop/leftBar";
// import rightBar from "@/components/desktop/rightBar";
// import mainPanel from "@/components/desktop/mainPanel";

export default {
  components: {
    leftBar: () => import("@/components/desktop/leftBar"),
    rightBar: () => import("@/components/desktop/rightBar"),
    mainPanel: () => import("@/components/desktop/mainPanel")
    // mainPanel
  },
  data() {
    return {};
  },
  computed: {
    header() {
      return this.$store.getters.header;
    }
  },
  mounted() {
    // console.log('operator', this.$store.getters.operatorType);
  }
};
</script>
